export default "/images/vendor/flag-icons/flags/4x3/ga.svg?ccf7eecbecdd26d2403c01bab2c28528";